import api from '@/util/app-api'

class OffDatesService {
  get (id) {
    return api.get('admin/offdates/get/'+id)
  }

  list () {
    return api.get('admin/offdates/list')
  }

  modify (items) {
    return api.post('admin/offdates/modify', items)
  }
}

export default new OffDatesService()
